import React from 'react';
import { Flex, Icon, Text, Link, Badge, useColorMode } from '@chakra-ui/react';
import { ArrowSquareOut } from '@phosphor-icons/react';

const formatEur = (cents: number) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);

const padNumber = (n: number): string => String(n).padStart(6, '0');

export const InvoiceRow = ({
  id,
  number,
  inDefaultReceipt,
  inputData,
  url,
  payment,
  company,
  subscription,
  // Payout-specific fields
  amount,
  month,
  year,
  payedOut,
  packageStation,
}: any) => {
  const { colorMode } = useColorMode();
  const displayNumber = padNumber(number);

  // Determine item type
  const isPayout = amount !== undefined && (month !== undefined || year !== undefined);
  const isAPPayout = isPayout && inputData?.accessPointID;

  // Build description
  let description = inputData?.description || inputData?.iid || '';
  if (!description && isPayout) {
    // Fallback for old Stripe payouts without a description field
    const name = [inputData?.firstName, inputData?.lastName].filter(Boolean).join(' ');
    description = name ? `Auszahlung ${name}${month && year ? ` – ${month}/${year}` : ''}` : `Auszahlung ${month || ''}/${year || ''}`;
  }

  // Badge
  let badgeLabel: string | null = null;
  let badgeColor = 'gray';
  if (isAPPayout) {
    badgeLabel = 'UPS AP';
    badgeColor = 'purple';
  } else if (isPayout) {
    badgeLabel = 'Auszahlung';
    badgeColor = 'green';
  } else if (payment?.type) {
    badgeLabel = payment.type;
  } else if (company?.paymentMethod) {
    badgeLabel = company.paymentMethod;
  }

  return (
    <Flex borderWidth="1px" px="4" py="4" rounded="md" flexDirection="column" mb="2">
      <Flex gap="2" mb="1">
        {badgeLabel ? <Badge colorScheme={badgeColor}>{badgeLabel}</Badge> : null}
      </Flex>

      <Text as="h4" fontSize="lg" fontFamily="heading">
        Rechnung {displayNumber} - {description}
        {subscription ? ` - ${subscription.subscriptionId}` : ''}
      </Text>

      {/* Payment amounts (Receipts) */}
      {payment ? (
        <Flex alignItems="center" justifyContent="space-between">
          <Text>Betrag: {formatEur(inDefaultReceipt ? payment.amount : payment.amount + payment.dropfriendsAmount)}</Text>
          <Text>DropFriends-Betrag: {formatEur(payment.dropfriendsAmount)}</Text>
        </Flex>
      ) : null}

      {/* Payout amount */}
      {isPayout && amount ? <Text>Betrag: {formatEur(amount)}</Text> : null}

      <Flex alignItems="center" justifyContent="space-between" mt="1">
        <Link href={url} isExternal color={colorMode === 'light' ? 'brand.500' : 'brand.400'}>
          {isPayout ? 'Beleg ansehen' : 'Rechnung ansehen'}
          <Icon as={ArrowSquareOut} size="16" fontSize="md" aria-label="external-link" mx="1" />
        </Link>
      </Flex>
    </Flex>
  );
};
